// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__nLBOT","label":"Labeled_label__2qXYr","divider":"Labeled_divider__2cYMa"};